<template>
    <div>
        <Menu-component />
        <div class="container">
            <h1>Segurança Hídrica: do conceito à aplicação prática no planejamento da infraestrutura hídrica estratégica do Brasil.</h1>
            <p>A garantia da segurança hídrica para o desenvolvimento sustentável do Brasil é a missão institucional da Agência Nacional de Águas (ANA) e uma das principais atribuições do Ministério do Desenvolvimento Regional (MDR).</p>
            <h2>O PNSH oferece o Caminho da Segurança Hídrica no Brasil</h2>
            <p>Realizado de forma pioneira e inovadora, a partir de diretrizes e critérios advindos do conceito de Segurança Hídrica, o PNSH assegura ao Brasil um planejamento integrado e consistente de infraestrutura hídrica, com natureza estratégica e relevância regional, com base nos principais problemas de segurança hídrica do país.</p>
            <p>O PNSH, assim, se soma ao planejamento da gestão de recursos hídricos e preenche o rol de instrumentos necessários ao alcance de objetivos da Política Nacional de Recursos Hídricos, que estabelece a necessidade de assegurar à atual e às futuras gerações a adequada disponibilidade de água e de atuar na prevenção contra eventos hidrológicos críticos.</p>
        </div>
        <router-link tag="button" class="btn-green" to="seguranca">O índice de Segurança Hidrica</router-link>
    </div>
</template>

<script>
import Menu from '@/components/Menu'

export default {
    components: {
        'Menu-component': Menu
    }
}
</script>

<style lang="scss" scoped>
.container  {
    padding: 130px 16px 0 16px;

    h1 {
        color: #8fc74a;
        font-size: 28px;
        font-weight: 500;
        font-family: 'rubik_medium';
        margin-bottom: 20px;
    }

    p {
        color: #565656;
        font-size: 14px;
        line-height: 26px;
        margin-bottom: 50px;
    }

    h2 {
       color: #3994d0;
       font-size: 19px;
       font-weight: 500;
       font-family: 'rubik_medium';
       margin-top: 30px;
       margin-bottom: 20px;
    }
}

button {
    margin-top: 30px;
    width: 100%;
    margin: 0px;
    border-radius: 30px 30px 0 0;
    position: relative;
    &::after {
            content: "";
            position: absolute;
            right: 10px;
            top: 17px;
            background-repeat: no-repeat;
            background-image: url(../assets/seta-direita-branca.svg);
            width: 9px;
            height: 14px;
            @include media_tablet() {
                right: 35px;
             }
    }
}
</style>
